import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"
import PropTypes from "prop-types"

const ChevronUpIcon = props => {
  const { width = 10, onClick, index } = props

  return (
    <StaticImage
      src="../../../images/chevron-up-solid.svg"
      width={50}
      quality={95}
      formats={["AUTO", "WEBP", "AVIF"]}
      alt="Up Icon"
      style={{ width }}
      className={`up-icon icon-show up-icon-index-${index}`}
      onClick={onClick}
    />
  )
}

export default ChevronUpIcon

ChevronUpIcon.propTypes = {
  width: PropTypes.number,
}

ChevronUpIcon.defaultProps = {
  width: PropTypes.number,
}
